export enum DiagnosisValidationResult {
  NotRequired = "01",
  Added = "A",
  Valid = "V",
  Submittable = "Submittable",
}
